import { useIntl } from '@capsicum/common';
import { useMemo } from 'react';

export const useWCPledgeBasketTexts = () => {
	const { $t } = useIntl();

	const intlTexts = useMemo(
		() => ({
			addCountry: $t('worldChampionshipPledge.basketDetails.addCountry'),
			amountToPledge: $t('worldChampionshipPledge.basketDetails.amountToPledge'),
			country: $t('worldChampionshipPledge.basketDetails.country'),
			emptyBasketSubtitle: $t('worldChampionshipPledge.basketDetails.emptyBasketSubtitle'),
			emptyBasketTitle: $t('worldChampionshipPledge.basketDetails.emptyBasketTitle'),
			estimatedCHZBonus: $t('worldChampionshipPledge.basketDetails.estimatedCHZBonus'),
			estimatedCHZBonusTooltipFirstText: ({ bonusPercentage }: { bonusPercentage: string }) =>
				$t('worldChampionshipPledge.basketDetails.estimatedCHZBonusTooltipFirstText', {
					bonusPercentage: bonusPercentage
				}),
			estimatedCHZBonusTooltipSecondText: $t(
				'worldChampionshipPledge.basketDetails.estimatedCHZBonusTooltipSecondText'
			),
			minimumPledgeAmount: ({ minimumPledgeAmount }: { minimumPledgeAmount: string }) =>
				$t('worldChampionshipPledge.basketDetails.minimumPledgeAmount', {
					minimumPledgeAmount
				}),
			title: $t('worldChampionshipPledge.basketDetails.title'),
			totalPledge: $t('worldChampionshipPledge.basketDetails.totalPledge'),
			usdToChzConversionDisplay: ({
				chzAmount,
				usdAmount
			}: {
				chzAmount: number | string;
				usdAmount: number | string;
			}) =>
				$t('worldChampionshipPledge.basketDetails.usdToChz', {
					chzAmount,
					usdAmount
				}),
			walletBalance: $t('worldChampionshipPledge.basketDetails.walletBalance')
		}),
		[$t]
	);

	return { intlTexts };
};
